var SCM = SCM || {};

SCM.ArticleListResources = SCM.ArticleListResources || {};

SCM.ArticleListResources.registerSnippetViewMore = function () {
    $(document).on('click', '.al-article-snippet-view-more', function () {
        $(this).parent('.al-article-snippet').toggleClass('collapsed expanded');
    });
};

SCM.ArticleListResources.getArticleDetails = function () {
    $(document).ready(function () {
        var accessCheckArticleIds = '';

        var $accessCheckArticles = $('.al-article-items[data-article-id]').has('.Locked').each(function () {
            if (accessCheckArticleIds.length > 0) accessCheckArticleIds += ',';

            accessCheckArticleIds += $(this).attr('data-article-id');
        });

        if (accessCheckArticleIds.length > 0) {
            var journalIds = $('.article-list-resources').first().attr('data-journalIds');

            $.post('/Article/ArticleListResourcesDetails',
                 { journalIds: journalIds, accessCheckArticleIds: accessCheckArticleIds },
                 function (data) {
                     for (var articleId in data) {
                         var $articleAccessType = $('.al-article-items[data-article-id="' + articleId + '"]').find('.article-accessType');
                         $articleAccessType.removeClass('Locked').addClass(data[articleId]);
                     }
                 },
                 'json'
            );
        }
    });
};

SCM.ArticleListResources.hideEmptyItems = function () {
    $(document).ready(function () {
        $('.resource-links-info .item:empty').addClass('hide');
    });
}

SCM.ArticleListResources.registerSnippetViewMore();
SCM.ArticleListResources.getArticleDetails();
SCM.ArticleListResources.hideEmptyItems();